import { Event, EventType } from "./Event";

import type { IAddSectionViewEvent } from "./types";

export class AddSectionViewEvent extends Event {
  constructor({
    section,
    tracking,
    customEventProperties,
  }: IAddSectionViewEvent) {
    super({
      event_type: EventType.section_view,
      event_properties: {
        section,
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
